import React from "react";
import './Cards.scss'
// import { useDispatch, useSelector } from "react-redux";
import { Card, Slot, Button, Tooltip, ButtonGroup, ButtonIcon, CardV2 } from "pepsico-ds";
import InfoIcon from '../Icons/InfoIcon'
import CustomButtons from "./CustomButtons";

function ContractingCard({ key, cardName, cardDesc, appsAnalytics, appsCLM, onSelect, isAmesaUser, item, disabled=false, isTerzoUser }) {
    const analyticsText = cardName === "Sourcing (Launch RFx, Negotiation)"?"Sourcing Analytics":"Contract Analytics";
    const managementText = cardName === "Sourcing (Launch RFx, Negotiation)"?"Sourcing Management":"Contract Management (CLM)";
    return (
        <>

                            <div
                                    style={{
                                        minHeight: "150px",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div className="card-title-container">
                                        <div className="card-title">{cardName}</div>
                                        <div className="card-description">{cardDesc}</div>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end'
                                        }}
                                        className="app-card-footer"
                                    >
                                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                                                <div>
                                                   { 
                                                        (isTerzoUser || cardName === "Sourcing (Launch RFx, Negotiation)")  && (
                                                            <>
                                                                <div className="archlet-card-text" style={{textAlign: 'left', fontSize: '10px', fontWeight: '500', marginBottom: '5px'}}>{analyticsText}</div>
                                                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>                                           
                                                                    <CustomButtons appList={appsAnalytics} disabled={disabled} appCountToShow={1} isContractingCard={true}/>
                                                                    {
                                                                        item?.info &&
                                                                        <span style={{ marginLeft: "10px" }}><InfoIcon text={item?.info} direction="top-middle"/></span>
                                                                    }
                                                                </div>
                                                                
                                                            </>
                                                        ) 
                                                    }
                                                   
                                                </div>
                                                <div>
                                                    <div className="archlet-card-text" style={{textAlign: 'left', fontSize: '10px', fontWeight: '500', marginBottom: '5px'}}>{managementText}</div>
                                                    <CustomButtons appList={appsCLM} disabled={disabled} appCountToShow={1} isContractingCard={true}/>
                                                </div>
                                            </div>
                                    </div>
                            </div>

            
            
        </>
    );
}

export default ContractingCard;
